/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ProfileResponse } from './';
import {
    ProfileResponseFromJSON,
    ProfileResponseFromJSONTyped,
    ProfileResponseToJSON,
} from './';

/**
 * 
 * @export
 * @interface AdvancedSearchAdminResultsResponse
 */
export interface AdvancedSearchAdminResultsResponse {
    /**
     * 
     * @type {string}
     * @memberof AdvancedSearchAdminResultsResponse
     */
    algorithmName: string;
    /**
     * 
     * @type {Array<ProfileResponse>}
     * @memberof AdvancedSearchAdminResultsResponse
     */
    profiles: Array<ProfileResponse>;
}

/**
 * Check if a given object implements the AdvancedSearchAdminResultsResponse interface.
 */
export function instanceOfAdvancedSearchAdminResultsResponse(value: object): value is AdvancedSearchAdminResultsResponse {
    if (!('algorithmName' in value) || value['algorithmName'] === undefined) return false;
    if (!('profiles' in value) || value['profiles'] === undefined) return false;
    return true;
}

export function AdvancedSearchAdminResultsResponseFromJSON(json: any): AdvancedSearchAdminResultsResponse {
    return AdvancedSearchAdminResultsResponseFromJSONTyped(json, false);
}

export function AdvancedSearchAdminResultsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdvancedSearchAdminResultsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'algorithmName': json['algorithmName'],
        'profiles': ((json['profiles'] as Array<any>).map(ProfileResponseFromJSON)),
    };
}

export function AdvancedSearchAdminResultsResponseToJSON(value?: AdvancedSearchAdminResultsResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'algorithmName': value['algorithmName'],
        'profiles': ((value['profiles'] as Array<any>).map((v) => ProfileResponseToJSON(v))),
    };
}

